import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRecord = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M18.1496 10c0-4.50074-3.6489-8.14952-8.1496-8.14962-4.50081 0-8.14962 3.64881-8.14962 8.14962.0001 4.5007 3.64887 8.1496 8.14962 8.1496V20l-.515-.0136C4.37184 19.7271.271676 15.6273.0126491 10.5141L0 10C0 4.47726 4.47725 0 10 0l.5141.0126491C15.7979.280314 20 4.64973 20 10l-.0136.5141C19.7187 15.7978 15.3502 19.9999 10 20v-1.8504c4.5006-.0001 8.1495-3.6489 8.1496-8.1496Z" }), /* @__PURE__ */ _jsx("path", { d: "M13.9126 9.99978 8.04321 13.3885V6.61105l5.86939 3.38873Z" })]
});
export default SvgRecord;
